import { useContext } from 'react';
import translationMessages from 'locale';
import { defaultLocale } from 'utils/i18n';
import { LocaleContext } from 'context';

type TranslationMessages = typeof translationMessages;
type SupportedLocale = keyof TranslationMessages;

export type TranslationKey = keyof TranslationMessages[typeof defaultLocale];

const isSupportedLocale = (locale: string): locale is SupportedLocale =>
  locale in translationMessages;

const useTranslation = () => {
  const { locale } = useContext(LocaleContext);

  const t = (key: TranslationKey): string => {
    const messages = isSupportedLocale(locale)
      ? translationMessages[locale]
      : undefined;

    if (!messages?.[key]) {
      // eslint-disable-next-line no-console
      console.warn(`Translation '${key}' for locale '${locale}' not found.`);
    }

    return messages?.[key] || translationMessages[defaultLocale][key] || '';
  };

  return {
    t,
    locale,
  };
};

export default useTranslation;
